import { render, staticRenderFns } from "./DimensionView.vue?vue&type=template&id=16255852&scoped=true&"
import script from "./DimensionView.vue?vue&type=script&lang=js&"
export * from "./DimensionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16255852",
  null
  
)

export default component.exports